<template>
    <div>
        <v-bottom-navigation background-color="primary" dark class="mt-3">
            <v-btn v-if="redirect" color="primary" style="height:100%"
                   :disabled="loading"
                   :loading="loadingRedirect"
                   @click="redirectTask()">
                {{ $t('Redirect') }}
                <v-icon>mdi-subdirectory-arrow-left mdi-flip-v</v-icon>
            </v-btn>

            <v-btn v-if="rework" color="primary" style="height:100%"
                   :disabled="loading"
                   :loading="loadingRework"
                   @click="reworkTask()" >
                {{ $t('Rework') }}
                <v-icon>mdi-arrow-right-top-bold</v-icon>
            </v-btn>

            <v-btn v-if="close" color="primary" style="height:100%"
                   :disabled="loading"
                   :loading="loadingClose"
                   @click="closeTask()">
                {{ $t('Close') }}
                <v-icon>mdi-close-box-outline</v-icon>
            </v-btn>

            <v-btn v-if="complete" color="primary" style="height:100%"
                   :disabled="loading"
                   :loading="loadingComplete"
                   @click="completeTask()">
                {{ $t('Complete') }}
                <v-icon>mdi-checkbox-marked</v-icon>
            </v-btn>

            <slot name="action" />
        </v-bottom-navigation>

        <v-overlay v-if="loading" />
    </div>
</template>

<script>
    import TasksService from '@/services/TasksService.js'

    export default {
        props: {
            complete: {
                type: Boolean,
                default: false
            },
            rework: {
                type: Boolean,
                default: false
            },
            redirect: {
                type: Boolean,
                default: false
            },
            close: {
                type: Boolean,
                default: false
            },
            taskId: {
                type: Number,
                required: true,
                default: null
            }
        },

        data() {
            return {
                loadingComplete: false,
                loadingRework: false,
                loadingRedirect: false,
                loadingClose: false,
                loading: false,

                shouldReworkTask: false,
                shouldCloseTask: false
            }
        },

        methods: {

            async completeTask() {
                if (await this.$root.$confirm(this.$t('Confirm'), this.$t('ConfirmCompleteTask'))) {
                    this.resetLoadings()

                    this.loading = true
                    this.loadingComplete = true

                    this.shouldReworkTask = false
                    this.shouldCloseTask = false

                    this.$emit('complete', this.submitTask)
                }
            },

            async reworkTask() {

                if (await this.$root.$confirm(this.$t('Confirm'), this.$t('ConfirmReworkTask'))) {
                    this.resetLoadings()

                    this.loading = true
                    this.loadingRework = true

                    this.shouldReworkTask = true
                    this.shouldCloseTask = false

                    this.$emit('rework', this.submitTask)
                }
            },

            async redirectTask() {
                if (await this.$root.$confirm(this.$t('Confirm'), this.$t('ConfirmRedirectTask'))) {
                    this.resetLoadings()

                    this.loading = true
                    this.loadingRedirect = true

                    this.shouldReworkTask = true
                    this.shouldCloseTask = false

                    this.$emit('redirect', this.submitTask)
                }
            },

            async closeTask() {
                if (await this.$root.$confirm(this.$t('Confirm'), this.$t('ConfirmCloseTask'))) {
                    this.resetLoadings()
                    this.loading = true
                    this.loadingClose = true

                    this.shouldReworkTask = false
                    this.shouldCloseTask = true

                    this.$emit('close', this.submitTask)
                }
            },

            resetLoadings() {
                this.loading = false
                this.loadingComplete = false
                this.loadingRework = false
                this.loadingRedirect = false
                this.loadingClose = false
            },

            submitTask(inputdata) {
                const postData = {
                    rework: this.shouldReworkTask,
                    close: this.shouldCloseTask,
                    inputdata
                }
                return new Promise((error) => {
                    TasksService.completeTask(this.taskId, postData).then((res) => {
                        if (res.success) {
                            this.$emit('succeed', true)
                        } else {
                            this.$root.$notification(this.$t(res.message), 'error')
                        }
                    }).catch(() => {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                        error()
                    }).finally(() => {
                        this.resetLoadings()
                    })
                })
            }
        }
    }
</script>